import React from "react";
import { Table } from "reactstrap";
import { useClient } from "../../../../hooks";
import { ConfirmButton } from "../../components/ConfirmButton";
import { NotificationManager } from "react-notifications";
import { formatDateTime } from "../../util";
import { Link } from "react-router-dom";

export const ParentalConsent = ({ application, onChanged, match }) => {
  const { id, parental_consent_form, form } = application;
  const client = useClient();
  const { parent_guardian_first_name, parent_guardian_email } = form;
  const { submitted, email_sent, id: formId } = parental_consent_form;
  const baseUrl = `volunteer_applications/${id}`;

  async function onResend() {
    try {
      await client.post(`${baseUrl}/resend_parental_consent_form`);
    } catch (ex) {
      throw ex;
    }

    NotificationManager.success("Email sent");
    await onChanged();
  }

  return (
    <Table size="sm">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th />
          <th />
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{parent_guardian_first_name}</td>
          <td>{parent_guardian_email}</td>
          <td>
            <Link to={`/parental_consent_forms/${formId}`}>Link</Link>
          </td>
          <td>
            {submitted ? (
              <Link
                to={{
                  pathname: `${match.url}/parental_consent_form`,
                  state: parental_consent_form,
                }}
              >
                View response
              </Link>
            ) : null}
          </td>
          <td>
            <ul className="pl-0 tw-list-none text-muted">
              <li>
                {email_sent ? (
                  <>
                    <span className="fa fa-check-circle text-success" /> email
                    sent on <strong>{formatDateTime(email_sent)}</strong>
                  </>
                ) : (
                  <>
                    <span className="fa fa-times-circle text-danger" /> email
                    not sent
                  </>
                )}
              </li>
              <li>
                {submitted ? (
                  <>
                    <span className="fa fa-check-circle text-success" /> form
                    submitted on <strong>{formatDateTime(submitted)}</strong>
                  </>
                ) : (
                  <>
                    <span className="fa fa-times-circle text-danger" /> form not
                    submitted
                  </>
                )}
              </li>
            </ul>
          </td>
          <td>
            <ConfirmButton
              size="sm"
              onClick={onResend}
              disabled={!parent_guardian_first_name || !parent_guardian_email}
              confirmProps={{
                color: "warning",
                children: (
                  <>
                    <span className="fa fa-envelope mr-2" /> Confirm send?
                  </>
                ),
              }}
            >
              <span className="fa fa-envelope mr-2" /> Resend email
            </ConfirmButton>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
